/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

/*
 *
 * Polyfills (onClientEntry)
 * 
 */

exports.onClientEntry = () => {
  // IntersectionObserver for gatsby-image (Safari, IE)
  if (!window.IntersectionObserver) require(`intersection-observer`)

  // Object-fit/Object-position for gatsby-image (IE)
  const testImg = document.createElement(`img`)
  if (!testImg.style.objectFit || !testImg.style.objectPosition) {
    require(`object-fit-images`)()
  }
}

/*
 *
 * Secondary scripts
 * 
 */

// A11Y: Detect keyboard vs. mouse vs. touch input (for focus styling)
exports.onInitialClientRender = () => require(`what-input`)



// WEBPACK FOOTER //
// ./gatsby-browser.js